import React, {useEffect, useState} from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import {Card} from 'reactstrap';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {useTranslation} from 'react-i18next';
import {Pagination} from '../../../components/pagination/Pagination';
import {useNavigate} from 'react-router-dom';
import {usePagination} from '../../../shared/hooks/usePagination';
import UserTable from '../../administrator/users/components/UserTable';
import {IUser} from '../../administrator/users/interfaces/IUser';
import {usersManagementApi} from '../../../api';
import UserFilters from '../../administrator/users/components/UserFilters';

const Users = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [userList, setUserList] = useState<IUser[]>([]);
  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();
  const deleteUserHandler = async (selectedUser: IUser) => {
    if (selectedUser?.id) {
      const {
        data: {data},
      } = await usersManagementApi.deleteUser(selectedUser?.id);
      setUserList(data);
    }
  };
  useEffect(() => {
    usersManagementApi.getAllUsers(pagination).then((response) => {
      const {data} = response;
      setUserList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    });
  }, [pagination, setTotalPages]);

  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2 justify-content-between">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle icon="ni-users" tag="h4">
                  {t('management.users.userList')}
                </BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/management/users/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('management.users.addNew')}
                </Button>
              </div>
            </div>
            <UserFilters isManagementList={true} changeFilterHandler={changeFilterHandler} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview">
          <UserTable
            isManagementList={true}
            userList={userList}
            setUserList={setUserList}
            navigateRoute="/app/management/users/update/"
            deleteUserHandler={deleteUserHandler}
          />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default Users;
